import FalconComponentCard from "components/common/FalconComponentCard";
import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FiDownloadCloud } from "react-icons/fi";
import { MdAdd } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";
import EmpolyeeListFilter from "./components/EmpolyeeListFilter";
import EmpolyeeListTable from "./components/EmpolyeeListTable";
import { toast } from "react-toastify";
import { GetAllEmpolyee } from "./config/empolyeeApi";
import { handleEmpolyeeReset } from "./config/empolyeeSlice";
import { nationalityData } from "features/practitioner/utils";
import { handleDownloadXLSX } from "helpers/excel";
import moment from "moment";

const EmpolyeeList = () => {
  const dispatch = useDispatch();
  const { empolyeeDataList, empolyeeFilters } = useSelector(
    (state) => state.empolyee
  );

  const { allPermissionType } = useSelector((state) => state.role);
  const empolyeeSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Employee"
  );
  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));
  const { control, watch, handleSubmit, reset, setValue } = useForm({
    defaultValues: {
      branch: "",
      name: "",
      email: "",
      id: "",
      role: "",
    },
  });

  const navigate = useNavigate();
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const requestBody = (customPage = page, customLimit = rowsPerPage) => ({
    emp_name: empolyeeFilters?.emp_name || "",
    branch_id:
      empolyeeFilters?.branch_id?.branch_id ||
      selectedBranch?.branch_id ||
      selectedBranch?.value ||
      "",
    emp_natid: empolyeeFilters?.emp_natid || "",
    emp_email: empolyeeFilters?.emp_email || "",
    syspri_id: empolyeeFilters?.syspri_id?.syspri_id || "",
    start_point: customPage,
    limit: customLimit,
  });
  const fetchEmpolyeeList = async (body = {}) => {
    try {
      const response = await dispatch(GetAllEmpolyee(body)).unwrap();
      setTotalRows(response?.total_rows || 0);
    } catch (error) {
      toast.error("Something Went Wrong");
    }
  };

  useEffect(() => {
    const body = requestBody(page, rowsPerPage);
    fetchEmpolyeeList(body);
  }, [page, rowsPerPage]);

  const handlePageChange = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const handlePerRowsChange = useCallback((newPerPage) => {
    setRowsPerPage(newPerPage);
    setPage(0); // Reset to first page when changing page size
  }, []);

  const handleCheckListFilter = () => {
    const newPage = 0;
    setPage(newPage); // Reset page
    const body = requestBody(newPage, rowsPerPage);
    fetchEmpolyeeList(body);
  };

  const handleReset = async () => {
    const body = {
      emp_name: "",
      branch_id: "",
      emp_natid: "",
      emp_email: "",
      syspri_id: "",
      start_point: 0,
      limit: 10,
    };
    setPage(0);
    setRowsPerPage(10);
    reset();
    dispatch(handleEmpolyeeReset());
    const resetBody = requestBody(0, 10); // Fresh filters
    await fetchEmpolyeeList(body);
  };

  const handleDownloadExcel = async () => {
    const excelBody = requestBody(page, totalRows);
    await fetchEmpolyeeList(excelBody);
    const flattenedArray =
      empolyeeDataList &&
      empolyeeDataList?.length > 0 &&
      empolyeeDataList?.map((row, index) => [
        page * rowsPerPage + index + 1 || "",
        `${row?.employees_firstname || ""} `,
        ` ${row?.employees_familyname || ""}`,
        `${row?.employees_firstname_arabic || ""} `,
        ` ${row?.employees_familyname_arabic || ""}`,
        row?.empolyee_dob || "",
        row?.nationality ||
        nationalityData?.find(
          (item) => item?.value === row?.employees_nationality
        )?.title ||
        "",
        row?.employees_mobilenumber || "",
        row?.employees_emailid || "",
        row?.employees_nationalid || "",
        row?.branch_name || "",
        row?.rolename || "",
      ]);
    handleDownloadXLSX(
      [
        [
          "No.",
          "First Name (English)",
          "Family Name (English)",
          "First Name  (Arabic)",
          "Family Name (Arabic)",
          "DOB",
          "Nationality",
          "Mobile No",
          "Email",
          "National Id",
          "Branch",
          "System Privilage",
        ],
        ...(flattenedArray || []),
      ],
      `User_List_Export_${moment().format("DD-MM-YYYY_hh:mm:ss")}`
    );
  };

  return (
    <>
      {Number(empolyeeSetting?.list) === 1 ? (
        <Form
          noValidate
          onSubmit={handleSubmit(handleCheckListFilter)}
          className="p-0"
        >
          <FalconComponentCard
            className="shadow-md"
            style={{ position: "relative" }}
          >
            <FalconComponentCard.Header
              className="d-flex  fixed-header justify-content-between align-items-center"
              sx={{
                position: "sticky !important",
                top: 68,
                zIndex: 1020,
                backgroundColor: "white",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <Col xs="auto m-0">
                <h5 className="text-primary mb-0 fs-10">User List</h5>
              </Col>
              <Col xs="auto" className="d-flex gap-2">
                <Button size="sm" variant="outline-danger" onClick={handleReset}>
                  Reset
                </Button>
                <Button type="submit" size="sm" variant="success">
                  Filter
                </Button>
                {Number(empolyeeSetting?.add) === 1 && (
                  <Button
                    size="sm"
                    variant="secondary"
                    onClick={() => navigate(paths.addEmpolyeeList)}
                  >
                    <MdAdd />
                    New
                  </Button>
                )}
                {Number(empolyeeSetting?.export) === 1 && (
                  <Button size="sm" variant="warning" onClick={handleDownloadExcel}>
                    <FiDownloadCloud size={16} />
                    Excel
                  </Button>
                )}
              </Col>
            </FalconComponentCard.Header>
            <FalconComponentCard.Body
              style={{
                marginTop: "40px", // Adjust this value based on header height
                overflowY: "auto",
                maxHeight: "calc(100vh - 200px)", // Adjust based on your needs
              }}
            >
              <EmpolyeeListFilter
                watch={watch}
                setValue={setValue}
                control={control}
              />
              <EmpolyeeListTable
                data={empolyeeDataList}
                totalRows={totalRows}
                handlePageChange={handlePageChange}
                handlePerRowsChange={handlePerRowsChange}
                page={page}
                setting={empolyeeSetting}
                rowsPerPage={rowsPerPage}
              />
            </FalconComponentCard.Body>
          </FalconComponentCard>
        </Form>
      ) : (
        <div className="py-6 text-center border rounded-3mb-3">
          <h5 className="text-danger">Permission Denied</h5>
          <p className="text-muted fs-11">
            You do not have permission to view User list.
          </p>
        </div>
      )}
    </>
  );
};

export default EmpolyeeList;
